import React, { useState, FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { api } from "../../../api";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { StatusUpdateDailog } from "../StatusUpdateDialog";

const terminalSchema = yup.object().shape({
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
});

type StatusUpdateAuthenticationDialogProps = {
  statusUpdateClose: () => void;
  statusAuthClose: () => void;
  loggedUserObject: any;
};
export const StatusUpdateAuthenticationDialog: FunctionComponent<
  StatusUpdateAuthenticationDialogProps
> = ({
  statusUpdateClose,
  loggedUserObject,
  statusAuthClose,
}) => {
  const [notAuthorised, setNotAuthorised] = useState(false);
  const [authorisedUser, setAuthorisedUser] = useState(false);
  const [error, setError] = useState(null);
  const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
    (props, ref) => <RouterLink innerRef={ref} {...props} />
  );
  const StatusUpdateDailogClose = () => {
    setAuthorisedUser(false);
    statusUpdateClose();
  };
  const closeDialog = () => {
    setAuthorisedUser(false);
    statusAuthClose();
  };
  return (
    <div>
      <Dialog open>
        <Formik
          enableReinitialize
          validationSchema={terminalSchema}
          initialValues={{
            username: "",
            password: "",
          }}
          onSubmit={async (values) => {
            try {
              const CredentialObject = {
                username: values.username,
                password: values.password,
                privilege: "pos_user_management",
                action: "edit",
              };
              let credentialResult = await api.post(
                `permissions/verify`,
                {},
                CredentialObject
              );

              if (credentialResult) {
                setAuthorisedUser(true);

                setAuthorisedUser(true);
              } else {
                setNotAuthorised(true);
                setAuthorisedUser(false);
              }
            } catch (error) {
              setError(error.error);
            }
          }}
        >
          {({ values, handleChange }) => (
            <Form>
              <DialogContent>
                <DialogContentText>
                  Please enter Admin credentials
                </DialogContentText>

                <TextField
                  margin="dense"
                  name="username"
                  variant="outlined"
                  onChange={handleChange}
                  value={values.username}
                  label="User Name"
                  type="name"
                  fullWidth
                />
                <ErrorMessage name="username">
                  {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                </ErrorMessage>
                <TextField
                  margin="dense"
                  name="password"
                  variant="outlined"
                  onChange={handleChange}
                  value={values.password}
                  label="Password"
                  type="password"
                  fullWidth
                />
                <ErrorMessage name="password">
                  {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                </ErrorMessage>
              </DialogContent>
              <DialogActions>
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
                <Button
                  onClick={statusUpdateClose}
                  variant="contained"
                  color="primary"
                >
                  Cancel
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
      {notAuthorised ? (
        <div>
          <Dialog
            open={notAuthorised}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are not authorised for this action
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setNotAuthorised(false)}
                component={NavLink}
                to={`/`}
              >
                ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : (
        ""
      )}

      {authorisedUser ? (
        <StatusUpdateDailog
          StatusUpdateDailogClose={StatusUpdateDailogClose}
          loggedUserObject={loggedUserObject}
          closeDialog={closeDialog}
        />
      ) : (
        ""
      )}
    </div>
  );
};
